import { autoVeloSiteCallForAMethod } from '@wix/bi-logger-auto-velo/v2';
import { listOrders as universalListOrders, getOrder as universalGetOrder, updateOrder as universalUpdateOrder, bulkUpdateOrders as universalBulkUpdateOrders, confirmOrder as universalConfirmOrder, getSummary as universalGetSummary, getInvoicePreview as universalGetInvoicePreview, getCheckoutOptions as universalGetCheckoutOptions, listAvailableTickets as universalListAvailableTickets, queryAvailableTickets as universalQueryAvailableTickets, createReservation as universalCreateReservation, cancelReservation as universalCancelReservation, getInvoice as universalGetInvoice, checkout as universalCheckout, updateCheckout as universalUpdateCheckout, posCheckout as universalPosCheckout, } from './events-v1-order.universal';
import { SubdivisionType, OrderStatus, ChannelType, TaxType, FeeName, FeeType, OrderType, OrderFieldset, OrderTag, WebhookIdentityType, ReservationStatus, State, TicketSaleStatus, Type, TicketDefinitionFieldset, } from './events-v1-order.universal';
function wrapSideEffect(sideEffect) {
    return (...args) => {
        try {
            sideEffect(...args);
        }
        catch (e) {
            // add some kind of log?
        }
    };
}
function createSideEffects(sideEffects) {
    return Object.entries(sideEffects).reduce((acc, [key, value]) => {
        acc[key] = wrapSideEffect(value);
        return acc;
    }, {});
}
function createVeloSiteCallLogData(params) {
    return autoVeloSiteCallForAMethod(Object.assign({ environment: 'front-end', entity_name: 'wix.events.v1.order', module_name: 'wix-events.v2' }, params));
}
export function sdkFactory({ appEssentials }) {
    const httpClient = appEssentials.httpClient;
    const logger = appEssentials
        .biLoggerFactory({ endpoint: 'auto-velo' })
        .logger();
    return {
        listOrders: (options) => {
            const methodLogData = {
                method_name: 'listOrders',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.listOrders',
            };
            return universalListOrders(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getOrder: (identifiers, options) => {
            const methodLogData = {
                method_name: 'getOrder',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.getOrder',
            };
            return universalGetOrder(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateOrder: (identifiers, options) => {
            const methodLogData = {
                method_name: 'updateOrder',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.updateOrder',
            };
            return universalUpdateOrder(identifiers, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        bulkUpdateOrders: (eventId, options) => {
            const methodLogData = {
                method_name: 'bulkUpdateOrders',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.bulkUpdateOrders',
            };
            return universalBulkUpdateOrders(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        confirmOrder: (eventId, options) => {
            const methodLogData = {
                method_name: 'confirmOrder',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.confirmOrder',
            };
            return universalConfirmOrder(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getSummary: (options) => {
            const methodLogData = {
                method_name: 'getSummary',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.getSummary',
            };
            return universalGetSummary(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getInvoicePreview: (identifiers) => {
            const methodLogData = {
                method_name: 'getInvoicePreview',
                service_name: 'wix.events.ticketing.OrderManagement',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.OrderManagement.getInvoicePreview',
            };
            return universalGetInvoicePreview(identifiers, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getCheckoutOptions: () => {
            const methodLogData = {
                method_name: 'getCheckoutOptions',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.getCheckoutOptions',
            };
            return universalGetCheckoutOptions(
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        listAvailableTickets: (options) => {
            const methodLogData = {
                method_name: 'listAvailableTickets',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.listAvailableTickets',
            };
            return universalListAvailableTickets(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        queryAvailableTickets: (options) => {
            const methodLogData = {
                method_name: 'queryAvailableTickets',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.queryAvailableTickets',
            };
            return universalQueryAvailableTickets(options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        createReservation: (eventId, options) => {
            const methodLogData = {
                method_name: 'createReservation',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.createReservation',
            };
            return universalCreateReservation(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        cancelReservation: (_id, eventId) => {
            const methodLogData = {
                method_name: 'cancelReservation',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.cancelReservation',
            };
            return universalCancelReservation(_id, eventId, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        getInvoice: (reservationId, eventId, options) => {
            const methodLogData = {
                method_name: 'getInvoice',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.getInvoice',
            };
            return universalGetInvoice(reservationId, eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        checkout: (eventId, options) => {
            const methodLogData = {
                method_name: 'checkout',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.checkout',
            };
            return universalCheckout(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        updateCheckout: (orderNumber, eventId, options) => {
            const methodLogData = {
                method_name: 'updateCheckout',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.updateCheckout',
            };
            return universalUpdateCheckout(orderNumber, eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        posCheckout: (eventId, options) => {
            const methodLogData = {
                method_name: 'posCheckout',
                service_name: 'wix.events.ticketing.CheckoutService',
            };
            const sideEffects = createSideEffects({
                onSuccess: (result) => {
                    var _a, _b;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_b = (_a = result.status) === null || _a === void 0 ? void 0 : _a.toString) === null || _b === void 0 ? void 0 : _b.call(_a) })));
                },
                onError: (error) => {
                    var _a, _b, _c;
                    logger.report(createVeloSiteCallLogData(Object.assign(Object.assign({}, methodLogData), { http_code: (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b), failure_reason: error.message })));
                },
            });
            const additionalHeaders = {
                'x-wix-bi-gateway': 'package-name=wix-events.v2,entity=wix.events.v1.order,environment=velo-frontend,method-fqn=wix.events.ticketing.CheckoutService.posCheckout',
            };
            return universalPosCheckout(eventId, options, 
            // @ts-ignore
            { httpClient, sideEffects, additionalHeaders });
        },
        SubdivisionType,
        OrderStatus,
        ChannelType,
        TaxType,
        FeeName,
        FeeType,
        OrderType,
        OrderFieldset,
        OrderTag,
        WebhookIdentityType,
        ReservationStatus,
        State,
        TicketSaleStatus,
        Type,
        TicketDefinitionFieldset,
    };
}
//# sourceMappingURL=events-v1-order.frontend.js.map